export default __webpack_public_path__ + "static/media/37.5d5091cb.png";